// ============================================================
// 📁 آدرس این فایل در پروژه:
//    src/services/api.ts
// 
// این فایل را در همان مسیر بالا کپی کنید (روی فایل قبلی بنویسید)
// ============================================================

// process.env در Create React App توسط webpack تعریف می‌شود
// declare می‌کنیم تا TypeScript ارور ندهد
declare const process: { env: { REACT_APP_API_URL?: string } };

const API_BASE = process.env.REACT_APP_API_URL || 'https://www.hamidigroupfinance.com/api';

const getToken = () => localStorage.getItem('auth_token');

const headers = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${getToken()}`,
});

const post = async (endpoint: string, data: object) => {
  const res = await fetch(`${API_BASE}/${endpoint}`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify(data),
  });
  return res.json();
};

// Auth
export const authAPI = {
  login: (username: string, password: string, remember: boolean) =>
    post('auth.php', { action: 'login', username, password, remember }),
  logout: () =>
    post('auth.php', { action: 'logout' }),
  verify: () =>
    post('auth.php', { action: 'verify' }),
};

// Users
export const usersAPI = {
  list: () =>
    post('users.php', { action: 'list' }),
  add: (data: object) =>
    post('users.php', { action: 'add', ...data }),
  update: (data: object) =>
    post('users.php', { action: 'update', ...data }),
  updatePermissions: (id: number, permissions: object) =>
    post('users.php', { action: 'update_permissions', id, permissions }),
  toggleStatus: (id: number) =>
    post('users.php', { action: 'toggle_status', id }),
  delete: (id: number) =>
    post('users.php', { action: 'delete', id }),
  logs: (userId: number) =>
    post('users.php', { action: 'logs', userId }),
  updateAvatar: (id: number, avatar: string) =>
    post('users.php', { action: 'update_avatar', id, avatar }),
};

// Settings
export const settingsAPI = {
  get: () =>
    post('settings.php', { action: 'get' }),
  update: (data: object) =>
    post('settings.php', { action: 'update', ...data }),
};

// Logs
export const logsAPI = {
  list: (data?: object) =>
    post('logs.php', { action: 'list', ...data }),
  add: (logAction: string, page: string, details: string, recordId?: number) =>
    post('logs.php', { action: 'add', logAction, page, details, recordId }),
  clear: (days: number) =>
    post('logs.php', { action: 'clear', days }),
};

export const hrAPI = {
  dashboard:       () => post('hr.php', { action: 'dashboard' }),
  employeesList:   (data?: object) => post('hr.php', { action: 'employees_list', ...data }),
  employeeGet:     (id: number) => post('hr.php', { action: 'employee_get', id }),
  employeeAdd:     (data: object) => post('hr.php', { action: 'employee_add', ...data }),
  employeeUpdate:  (data: object) => post('hr.php', { action: 'employee_update', ...data }),
  employeeDelete:  (id: number) => post('hr.php', { action: 'employee_delete', id }),
  contractAdd:     (data: object) => post('hr.php', { action: 'contract_add', ...data }),
  contractUpdate:  (data: object) => post('hr.php', { action: 'contract_update', ...data }),
  salaryAdd:       (data: object) => post('hr.php', { action: 'salary_add', ...data }),
  salaryPay:       (id: number, payment_date: string) => post('hr.php', { action: 'salary_pay', id, payment_date }),
  salaryDelete:    (id: number) => post('hr.php', { action: 'salary_delete', id }),
  loanAdd:         (data: object) => post('hr.php', { action: 'loan_add', ...data }),
  loanUpdate:      (data: object) => post('hr.php', { action: 'loan_update', ...data }),
  loanDelete:      (id: number) => post('hr.php', { action: 'loan_delete', id }),
  loanPayments:    (loan_id: number) => post('hr.php', { action: 'loan_payments_list', loan_id }),
  // 🆕 تراکنش‌های ساده کارمندان (مستقل از حساب‌های مالی)
  txList:          (employee_id: number) => post('hr.php', { action: 'tx_list', employee_id }),
  txAdd:           (data: object) => post('hr.php', { action: 'tx_add', ...data }),
  txUpdate:        (data: object) => post('hr.php', { action: 'tx_update', ...data }),
  txDelete:        (id: number) => post('hr.php', { action: 'tx_delete', id }),
  txBalances:      () => post('hr.php', { action: 'tx_balances' }),
};

// آپلود فایل
export const uploadAPI = {
  uploadPhoto: async (file: File): Promise<{success:boolean;url?:string;message?:string}> => {
    const token = localStorage.getItem('token');
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', 'employee');
    const response = await fetch(`${API_BASE}/upload.php`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}` },
      body: formData,
    });
    return response.json();
  },
};

export const customersAPI = {
  dashboard:       ()             => post('customers2.php', { action: 'dashboard' }),
  list:            (data?: object) => post('customers2.php', { action: 'list', ...data }),
  listParents:     ()             => post('customers2.php', { action: 'list_parents' }),
  get:             (id: number)   => post('customers2.php', { action: 'get', id }),
  add:             (data: object) => post('customers2.php', { action: 'add', ...data }),
  update:          (data: object) => post('customers2.php', { action: 'update', ...data }),
  delete:          (id: number)   => post('customers2.php', { action: 'delete', id }),
  getTransactions: (data: object) => post('customers2.php', { action: 'get_transactions', ...data }),
  syncJournal:     (customer_id: number) => post('customers2.php', { action: 'sync_journal', customer_id }),
  reportAll:       (data?: object) => post('customers2.php', { action: 'report_all', ...data }),
};

export const vendorsAPI = {
  dashboard:       ()             => post('vendors2.php', { action: 'dashboard' }),
  list:            (data?: object) => post('vendors2.php', { action: 'list', ...data }),
  listParents:     ()             => post('vendors2.php', { action: 'list_parents' }),
  get:             (id: number)   => post('vendors2.php', { action: 'get', id }),
  add:             (data: object) => post('vendors2.php', { action: 'add', ...data }),
  update:          (data: object) => post('vendors2.php', { action: 'update', ...data }),
  delete:          (id: number)   => post('vendors2.php', { action: 'delete', id }),
  syncJournal:     (vendor_id: number) => post('vendors2.php', { action: 'sync_journal', vendor_id }),
  reportAll:       (data?: object) => post('vendors2.php', { action: 'report_all', ...data }),
  getTransactions: (data: object) => post('vendors2.php', { action: 'get_transactions', ...data }),
};

export const goodsReceiptAPI = {
  pendingPurchasesList: (filters?: string | object) => post('goods_receipt.php', { action: 'pending_purchases_list', ...(typeof filters === 'string' ? { keyword: filters } : (filters || {})) }),
  receiptsHistory:      (data?: object) => post('goods_receipt.php', { action: 'receipts_history', ...data }),
  purchaseDetail:       (purchase_id: number) => post('goods_receipt.php', { action: 'purchase_detail', purchase_id }),
  itemDistributionRows: (purchase_item_id: number) => post('goods_receipt.php', { action: 'item_distribution_rows', purchase_item_id }),
  distributeBatch:      (data: object) => post('goods_receipt.php', { action: 'distribute_batch', ...data }),
  confirmReceipt:       (data: object) => post('goods_receipt.php', { action: 'confirm_receipt', ...data }),
  markWaste:            (data: object) => post('goods_receipt.php', { action: 'mark_waste', ...data }),
  deleteDistributionRow:(id: number) => post('goods_receipt.php', { action: 'delete_distribution_row', id }),
  uploadAttachment: async (file: File): Promise<{success:boolean;path?:string;file_name?:string;message?:string}> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await fetch(`${API_BASE}/journal_upload.php`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${getToken()}` },
      body: formData,
    });
    return response.json();
  },
};

export const warehouseAPI = {
  dashboard:           ()              => post('warehouse.php', { action: 'dashboard' }),
  unitsList:           ()              => post('warehouse.php', { action: 'units_list' }),
  unitAdd:             (d: object)     => post('warehouse.php', { action: 'unit_add', ...d }),
  unitUpdate:          (d: object)     => post('warehouse.php', { action: 'unit_update', ...d }),
  unitDelete:          (id: number)    => post('warehouse.php', { action: 'unit_delete', id }),
  productUnitsList:    (product_id: number) => post('warehouse.php', { action: 'product_units_list', product_id }),
  productUnitsSet:     (product_id: number, unit_ids: number[]) => post('warehouse.php', { action: 'product_units_set', product_id, unit_ids }),
  productCatsList:     ()              => post('warehouse.php', { action: 'product_cats_list' }),
  productCatAdd:       (d: object)     => post('warehouse.php', { action: 'product_cat_add', ...d }),
  productCatUpdate:    (d: object)     => post('warehouse.php', { action: 'product_cat_update', ...d }),
  productCatDelete:    (id: number)    => post('warehouse.php', { action: 'product_cat_delete', id }),
  serviceCatsList:     ()              => post('warehouse.php', { action: 'service_cats_list' }),
  serviceCatAdd:       (d: object)     => post('warehouse.php', { action: 'service_cat_add', ...d }),
  serviceCatUpdate:    (d: object)     => post('warehouse.php', { action: 'service_cat_update', ...d }),
  serviceCatDelete:    (id: number)    => post('warehouse.php', { action: 'service_cat_delete', id }),
  warehousesList:      ()              => post('warehouse.php', { action: 'warehouses_list' }),
  warehouseAdd:        (d: object)     => post('warehouse.php', { action: 'warehouse_add', ...d }),
  warehouseUpdate:     (d: object)     => post('warehouse.php', { action: 'warehouse_update', ...d }),
  warehouseDelete:     (id: number)    => post('warehouse.php', { action: 'warehouse_delete', id }),
  productsList:        (d?: object)    => post('warehouse.php', { action: 'products_list', ...d }),
  productGet:          (id: number)    => post('warehouse.php', { action: 'product_get', id }),
  productAdd:          (d: object)     => post('warehouse.php', { action: 'product_add', ...d }),
  productUpdate:       (d: object)     => post('warehouse.php', { action: 'product_update', ...d }),
  productDelete:       (id: number)    => post('warehouse.php', { action: 'product_delete', id }),
  servicesList:        (d?: object)    => post('warehouse.php', { action: 'services_list', ...d }),
  serviceAdd:          (d: object)     => post('warehouse.php', { action: 'service_add', ...d }),
  serviceUpdate:       (d: object)     => post('warehouse.php', { action: 'service_update', ...d }),
  serviceDelete:       (id: number)    => post('warehouse.php', { action: 'service_delete', id }),
  transactionAdd:      (d: object)     => post('warehouse.php', { action: 'transaction_add', ...d }),
  transactionsList:    (d?: object)    => post('warehouse.php', { action: 'transactions_list', ...d }),
  transferAdd:         (d: object)     => post('warehouse.php', { action: 'transfer_add', ...d }),
  transfersList:       (d?: object)    => post('warehouse.php', { action: 'transfers_list', ...d }),
  reportStockAll:      (d?: object)    => post('warehouse.php', { action: 'report_stock_all', ...d }),
  reportWarehouseStock:(id: number|string) => post('warehouse.php', { action: 'report_warehouse_stock', warehouse_id: id }),
  reportMovement:      (d: object)     => post('warehouse.php', { action: 'report_movement', ...d }),
  productLedger:       (d: object)     => post('warehouse.php', { action: 'product_ledger', ...d }),
  transferUpdate:      (d: object)     => post('warehouse.php', { action: 'transfer_update', ...d }),
  transferDelete:      (id: number)    => post('warehouse.php', { action: 'transfer_delete', id }),
  // 🆕 توابع تعدیل گروهی (Bulk Adjustment)
  transferBulkAdd:     (d: object)     => post('warehouse.php', { action: 'transfer_bulk_add', ...d }),
  transferBulkDelete:  (bulk_id: string) => post('warehouse.php', { action: 'transfer_bulk_delete', bulk_id }),
  transferBulkGet:     (bulk_id: string) => post('warehouse.php', { action: 'transfer_bulk_get', bulk_id }),
  transferBulkList:    (d?: object)    => post('warehouse.php', { action: 'transfer_bulk_list', ...d }),
};

export const accountsAPI = {
  list: () => post('accounts.php', { action: 'list' }),
  add: (data: object) => post('accounts.php', { action: 'add', ...data }),
  update: (data: object) => post('accounts.php', { action: 'update', ...data }),
  toggleStatus: (id: number) => post('accounts.php', { action: 'toggle_status', id }),
  delete: (id: number) => post('accounts.php', { action: 'delete', id }),
  getCashAccounts: () => post('accounts.php', { action: 'get_cash_accounts' }),
  report: (id: number, date_from?: string, date_to?: string) => post('accounts.php', { action: 'report', id, date_from, date_to }),
  excelReport: (id: number, date_from?: string, date_to?: string) => post('accounts.php', { action: 'account_excel_report', id, date_from, date_to }),
};

export const journalAPI = {
  dashboardStats:  (data?: object) => post('journal2.php', { action: 'dashboard_stats', ...data }),
  getExpenseCats:  () => post('journal2.php', { action: 'get_expense_cats' }),
  addExpenseCat:   (data: object) => post('journal2.php', { action: 'add_expense_cat', ...data }),
  updateExpenseCat:(data: object) => post('journal2.php', { action: 'update_expense_cat', ...data }),
  deleteExpenseCat:(id: number) => post('journal2.php', { action: 'delete_expense_cat', id }),
  getProductCats:  () => post('journal2.php', { action: 'get_product_cats' }),

  addPurchase:     (data: object) => post('journal2.php', { action: 'add_purchase', ...data }),
  listPurchases:   (data?: object) => post('journal2.php', { action: 'list_purchases', ...data }),
  uploadPurchaseAttachment: async (file: File): Promise<{success:boolean;path?:string;file_name?:string;message?:string}> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await fetch(`${API_BASE}/journal_upload.php`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${getToken()}` },
      body: formData,
    });
    return response.json();
  },
  updatePurchase:  (data: object) => post('journal2.php', { action: 'update_purchase', ...data }),
  deletePurchase:  (id: number) => post('journal2.php', { action: 'delete_purchase', id }),
  confirmPurchase: (id: number) => post('journal2.php', { action: 'confirm_purchase', id }),
  revertPurchase:  (id: number) => post('journal2.php', { action: 'revert_purchase', id }),

  addSale:         (data: object) => post('journal2.php', { action: 'add_sale', ...data }),
  addSaleFromCase: (data: object) => post('journal2.php', { action: 'add_sale_from_case', ...data }),
  caseReceiptSave:   (data: object) => post('journal2.php', { action: 'case_receipt_save', ...data }),
  caseReceiptDelete: (link_id: number) => post('journal2.php', { action: 'case_receipt_delete', link_id }),
  listSales:       (data?: object) => post('journal2.php', { action: 'list_sales', ...data }),
  updateSale:      (data: object) => post('journal2.php', { action: 'update_sale', ...data }),
  deleteSale:      (id: number) => post('journal2.php', { action: 'delete_sale', id }),
  confirmSale:     (id: number) => post('journal2.php', { action: 'confirm_sale', id }),
  revertSale:      (id: number) => post('journal2.php', { action: 'revert_sale', id }),

  addPaymentIn:    (data: object) => post('journal2.php', { action: 'add_payment_in', ...data }),
  listPaymentsIn:  (data?: object) => post('journal2.php', { action: 'list_payments_in', ...data }),
  updatePaymentIn: (data: object) => post('journal2.php', { action: 'update_payment_in', ...data }),
  deletePaymentIn: (id: number) => post('journal2.php', { action: 'delete_payment_in', id }),
  confirmPaymentIn:(id: number) => post('journal2.php', { action: 'confirm_payment_in', id }),
  revertPaymentIn: (id: number) => post('journal2.php', { action: 'revert_payment_in', id }),

  addPaymentOut:   (data: object) => post('journal2.php', { action: 'add_payment_out', ...data }),
  listPaymentsOut: (data?: object) => post('journal2.php', { action: 'list_payments_out', ...data }),
  updatePaymentOut:(data: object) => post('journal2.php', { action: 'update_payment_out', ...data }),
  deletePaymentOut:(id: number) => post('journal2.php', { action: 'delete_payment_out', id }),
  confirmPaymentOut:(id: number) => post('journal2.php', { action: 'confirm_payment_out', id }),
  revertPaymentOut:(id: number) => post('journal2.php', { action: 'revert_payment_out', id }),

  addExpense:      (data: object) => post('journal2.php', { action: 'add_expense', ...data }),
  listExpenses:    (data?: object) => post('journal2.php', { action: 'list_expenses', ...data }),
  updateExpense:   (data: object) => post('journal2.php', { action: 'update_expense', ...data }),
  payExpense:      (id: number, account_id: number, account_name: string) => post('journal2.php', { action: 'pay_expense', id, account_id, account_name }),
  confirmExpense:  (id: number) => post('journal2.php', { action: 'confirm_expense', id }),
  revertExpense:   (id: number) => post('journal2.php', { action: 'revert_expense', id }),
  deleteExpense:   (id: number) => post('journal2.php', { action: 'delete_expense', id }),

  addCogs:         (data: object) => post('journal2.php', { action: 'add_cogs', ...data }),
  listCogs:        (data?: object) => post('journal2.php', { action: 'list_cogs', ...data }),
  updateCogs:      (data: object) => post('journal2.php', { action: 'update_cogs', ...data }),
  payCogs:         (id: number, account_id: number, account_name: string) => post('journal2.php', { action: 'pay_cogs', id, account_id, account_name }),
  confirmCogs:     (id: number) => post('journal2.php', { action: 'confirm_cogs', id }),
  revertCogs:      (id: number) => post('journal2.php', { action: 'revert_cogs', id }),
  deleteCogs:      (id: number) => post('journal2.php', { action: 'delete_cogs', id }),
  addSaleFromCogs: (data: object) => post('journal2.php', { action: 'add_sale_from_cogs', ...data }),
  bulkSaleFromCogs: (data: object) => post('journal2.php', { action: 'bulk_sale_from_cogs', ...data }),

  addTransfer:     (data: object) => post('journal2.php', { action: 'add_transfer', ...data }),
  listTransfers:   (data?: object) => post('journal2.php', { action: 'list_transfers', ...data }),

  // گزارش کامل (همه‌ی ردیف‌ها یا مطابق فیلتر) و گزارش جامع ژورنال
  reportData:      (data: object) => post('journal2.php', { action: 'report_data', ...data }),
  journalReportFull: (data?: object) => post('journal2.php', { action: 'journal_report_full', ...data }),
  foreignSaleReceipts: (data?: object) => post('journal2.php', { action: 'foreign_sale_receipts', ...data }),
  // آپلود ضمیمه برای همه‌ی تراکنش‌ها (فایل یا صدا)
  uploadAttachment: async (file: File): Promise<{success:boolean;path?:string;file_name?:string;message?:string}> => {
    const formData = new FormData();
    formData.append('file', file);
    const response = await fetch(`${API_BASE}/journal_upload.php`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${getToken()}` },
      body: formData,
    });
    return response.json();
  },
  updateTransfer:  (data: object) => post('journal2.php', { action: 'update_transfer', ...data }),
  deleteTransfer:  (id: number) => post('journal2.php', { action: 'delete_transfer', id }),
  confirmTransfer: (id: number) => post('journal2.php', { action: 'confirm_transfer', id }),
  revertTransfer:  (id: number) => post('journal2.php', { action: 'revert_transfer', id }),
};

export const transitAPI = {
  offices:     () => post('transit.php', { action: 'offices' }),
  eligiblePurchases: (keyword?: string) => post('transit.php', { action: 'eligible_purchases', keyword }),
  eligibleSales: (keyword?: string) => post('transit.php', { action: 'eligible_sales', keyword }),
  list:        (data?: object) => post('transit.php', { action: 'list', ...data }),
  get:         (id: number) => post('transit.php', { action: 'get', id }),
  create:      (data: object) => post('transit.php', { action: 'create', ...data }),
  updateInfo:  (data: object) => post('transit.php', { action: 'update_info', ...data }),
  saveLeg:     (data: object) => post('transit.php', { action: 'save_leg', ...data }),
  deleteLeg:   (id: number) => post('transit.php', { action: 'delete_leg', id }),
  setLegStatus:(data: object) => post('transit.php', { action: 'set_leg_status', ...data }),
  complete:    (data: object) => post('transit.php', { action: 'complete', ...data }),
  reopen:      (id: number) => post('transit.php', { action: 'reopen', id }),
  remove:      (id: number) => post('transit.php', { action: 'delete', id }),
  // هزینه‌های مرحله: درخواست ← تأیید ← ثبت (COGS)
  expenseCategories: () => post('transit.php', { action: 'expense_categories' }),
  expenseSave:    (data: object) => post('transit.php', { action: 'expense_save', ...data }),
  expenseList:    (data?: object) => post('transit.php', { action: 'expense_list', ...data }),
  expenseApprove: (id: number) => post('transit.php', { action: 'expense_approve', id }),
  expenseReject:  (data: object) => post('transit.php', { action: 'expense_reject', ...data }),
  expenseRecord:  (data: object) => post('transit.php', { action: 'expense_record', ...data }),
  expenseDelete:  (id: number) => post('transit.php', { action: 'expense_delete', id }),
  expenseSummary: (transit_id: number) => post('transit.php', { action: 'expense_summary', transit_id }),
  // اتفاقات
  incidentSave:   (data: object) => post('transit.php', { action: 'incident_save', ...data }),
  incidentDelete: (id: number) => post('transit.php', { action: 'incident_delete', id }),
  // اعلان‌ها (زنگ هشدار)
  notifications:     () => post('transit.php', { action: 'notifications' }),
  notificationsRead: (data: object) => post('transit.php', { action: 'notifications_read', ...data }),
  // GPS
  gpsLink:      (data: object) => post('transit.php', { action: 'gps_link', ...data }),
  gpsLive:      (transit_id: number) => post('transit.php', { action: 'gps_live', transit_id }),
  gpsAddManual: (data: object) => post('transit.php', { action: 'gps_add_manual', ...data }),
  gpsLiveLight: (transit_id: number) => post('transit.php', { action: 'gps_live', transit_id, light: 1 }),
  // موترها (توزیع بار روی چند موتر در هر مرحله)
  truckSave:      (data: object) => post('transit.php', { action: 'truck_save', ...data }),
  truckSplit:     (data: object) => post('transit.php', { action: 'truck_split', ...data }),
  truckDelete:    (id: number) => post('transit.php', { action: 'truck_delete', id }),
  truckSetStatus: (data: object) => post('transit.php', { action: 'truck_set_status', ...data }),
  truckGpsLink:   (data: object) => post('transit.php', { action: 'truck_gps_link', ...data }),
  truckReport:    (id: number) => post('transit.php', { action: 'truck_report', id }),
  legRouteReport: (leg_id: number) => post('transit.php', { action: 'leg_route_report', leg_id }),
  salesOverview:  (transit_id: number) => post('transit.php', { action: 'sales_overview', transit_id }),
  saleLinkSave:   (data: object) => post('transit.php', { action: 'sale_link_save', ...data }),
  saleLinkDelete: (link_id: number) => post('transit.php', { action: 'sale_link_delete', link_id }),
  customerReceiptSave:   (data: object) => post('transit.php', { action: 'customer_receipt_save', ...data }),
  customerReceiptDelete: (link_id: number) => post('transit.php', { action: 'customer_receipt_delete', link_id }),
  caseClose:  (data: object) => post('transit.php', { action: 'case_close', ...data }),
  caseReopen: (transit_id: number) => post('transit.php', { action: 'case_reopen', transit_id }),
  caseBoard: (transit_id?: number) => post('transit.php', { action: 'case_board', transit_id: transit_id || 0 }),
  trucksReport:   (transit_id: number) => post('transit.php', { action: 'trucks_report', transit_id }),
  truckHandover:  (data: object) => post('transit.php', { action: 'truck_handover', ...data }),
  handoverUndo:   (event_id: number) => post('transit.php', { action: 'handover_undo', event_id }),
  deviceInfo:     (truck_id: number) => post('transit.php', { action: 'device_info', truck_id }),
  deviceSave:     (data: object) => post('transit.php', { action: 'device_save', ...data }),
  deviceDelete:   (truck_id: number) => post('transit.php', { action: 'device_delete', truck_id }),
  // گزارش جامع پرونده
  caseReport:   (transit_id: number) => post('transit.php', { action: 'case_report', transit_id }),
};

export const trackingAPI = {
  // گمرک‌ها
  listOffices:    () => post('tracking.php', { action: 'list_offices' }),
  addOffice:      (name: string) => post('tracking.php', { action: 'add_office', name }),
  updateOffice:   (id: number, name: string) => post('tracking.php', { action: 'update_office', id, name }),
  deleteOffice:   (id: number) => post('tracking.php', { action: 'delete_office', id }),

  // بارها
  listShipments:  () => post('tracking.php', { action: 'list_shipments' }),
  getShipment:    (id: number) => post('tracking.php', { action: 'get_shipment', id }),
  addShipment:    (data: object) => post('tracking.php', { action: 'add_shipment', ...data }),
  updateShipment: (data: object) => post('tracking.php', { action: 'update_shipment', ...data }),
  deleteShipment: (id: number) => post('tracking.php', { action: 'delete_shipment', id }),
  changeStatus:   (id: number, status: string, clearance_date?: string, auto_vendor_id?: number) => post('tracking.php', { action: 'change_status', id, status, clearance_date, auto_vendor_id }),

  // توزیع
  addDistribution:    (data: object) => post('tracking.php', { action: 'add_distribution', ...data }),
  updateDistribution: (data: object) => post('tracking.php', { action: 'update_distribution', ...data }),
  deleteDistribution: (id: number) => post('tracking.php', { action: 'delete_distribution', id }),

  // داشبورد و گزارش
  dashboard:       () => post('tracking.php', { action: 'dashboard' }),
  shortageReport:  (data?: object) => post('tracking.php', { action: 'shortage_report', ...data }),
  // 🆕 کسری‌های دستی از صفحه خرید
  shortageAdd:     (data: object) => post('tracking.php', { action: 'shortage_add', ...data }),
  shortageList:    (data?: object) => post('tracking.php', { action: 'shortage_list', ...data }),
  shortageDelete:  (id: number) => post('tracking.php', { action: 'shortage_delete', id }),
  // 🆕 پیدا کردن آیتم‌های بار از روی purchase_id (برای مقایسه در صفحه خرید)
  shipmentItemsForPurchase: (purchase_id: number) => post('tracking.php', { action: 'shipment_items_for_purchase', purchase_id }),
};

export const presidentAPI = {
  journalStats: (data?: object) => post('president.php', { action: 'journal_stats', ...data }),
  journalList:  (data?: object) => post('president.php', { action: 'journal_list',  ...data }),
  activityLogs: (data?: object) => post('president.php', { action: 'activity_logs', ...data }),
  usersSummary: ()              => post('president.php', { action: 'users_summary' }),
  userDetail:   (user_id: number, data?: object) => post('president.php', { action: 'user_activity_detail', user_id, ...data }),
};

export const chatAPI = {
  getRooms:        () => post('chat.php', { action: 'get_rooms' }),
  createRoom:      (data: object) => post('chat.php', { action: 'create_room', ...data }),
  getMessages:     (room_id: number, last_id?: number) => post('chat.php', { action: 'get_messages', room_id, last_id }),
  sendMessage:     (data: object) => post('chat.php', { action: 'send_message', ...data }),
  deleteMessage:   (id: number) => post('chat.php', { action: 'delete_message', id }),
  markRead:        (room_id: number) => post('chat.php', { action: 'mark_read', room_id }),
  getUnread:       () => post('chat.php', { action: 'get_unread' }),
  uploadFile:      async (file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('action', 'upload_file');
    const response = await fetch(`${API_BASE}/chat.php`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${getToken()}` },
      body: formData,
    });
    return response.json();
  },
  getUsers:        () => post('chat.php', { action: 'get_users' }),
  updateRoom:      (data: object) => post('chat.php', { action: 'update_room', ...data }),
  deleteRoom:      (id: number) => post('chat.php', { action: 'delete_room', id }),
  addMember:       (room_id: number, user_id: number) => post('chat.php', { action: 'add_member', room_id, user_id }),
  removeMember:    (room_id: number, user_id: number) => post('chat.php', { action: 'remove_member', room_id, user_id }),
  getCallHistory:  () => post('chat.php', { action: 'get_call_history' }),
  initiateCall:    (data: object) => post('chat.php', { action: 'initiate_call', ...data }),
  answerCall:      (call_id: number, accept: boolean) => post('chat.php', { action: 'answer_call', call_id, accept }),
  endCall:         (call_id: number) => post('chat.php', { action: 'end_call', call_id }),
  getIncomingCalls:() => post('chat.php', { action: 'get_incoming_calls' }),
  saveVoiceMessage:(data: object) => post('chat.php', { action: 'save_voice_message', ...data }),
  setAlarm:        (data: object) => post('chat.php', { action: 'set_alarm', ...data }),
  getAlarms:       () => post('chat.php', { action: 'get_alarms' }),
  deleteAlarm:     (id: number) => post('chat.php', { action: 'delete_alarm', id }),
  getSavedFiles:   () => post('chat.php', { action: 'get_saved_files' }),
  saveFile:        (data: object) => post('chat.php', { action: 'save_file', ...data }),
  deleteSavedFile: (id: number) => post('chat.php', { action: 'delete_saved_file', id }),
  pinMessage:       (message_id: number, room_id: number) => post('chat.php', { action: 'pin_message', message_id, room_id }),
  getPinnedMessages:(room_id: number) => post('chat.php', { action: 'get_pinned_messages', room_id }),
  // Calendar
  getEvents:        (data?: object) => post('chat.php', { action: 'get_events', ...data }),
  addEvent:         (data: object)  => post('chat.php', { action: 'add_event', ...data }),
  updateEvent:      (data: object)  => post('chat.php', { action: 'update_event', ...data }),
  deleteEvent:      (id: number)    => post('chat.php', { action: 'delete_event', id }),
  // Alarms
  updateAlarm:      (data: object)  => post('chat.php', { action: 'update_alarm', ...data }),
  // Profile
  updateProfile:    (data: object)  => post('chat.php', { action: 'update_profile', ...data }),
  getProfile:       ()              => post('chat.php', { action: 'get_profile' }),
};